export default {"src":"/_next/static/media/character-b.colour.88df74c2.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};